export default "__VITE_ASSET__wpbHzlmm__"